import { render, staticRenderFns } from "./YiShiDaLabelDialog.vue?vue&type=template&id=01bd461a&scoped=true"
import script from "./YiShiDaLabelDialog.vue?vue&type=script&lang=js"
export * from "./YiShiDaLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./YiShiDaLabelDialog.vue?vue&type=style&index=0&id=01bd461a&prod&scoped=true&lang=css"
import style1 from "./YiShiDaLabelDialog.vue?vue&type=style&index=1&id=01bd461a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd461a",
  null
  
)

export default component.exports